export default __webpack_public_path__ + "static/media/dashboard.f84ec93e.svg";